import { Component, Input } from '@angular/core';

@Component({
	selector: 'cmv-header-steps',
	templateUrl: './header-steps.component.html',
	styleUrls: ['./header-steps.component.scss'],
})
export class HeaderStepsComponent {
	@Input() numberSteps: number = 1;
	@Input() stepActive: number = 0;
	@Input() pr: string = '0%; -70 px;';
	@Input() image = './assets/images/accounts/personal-data.svg';
	@Input() showTitle: boolean = true;

	constructor() {}
}
